angular.module('app.directives', [])  

  .directive('scrollPage', ->
    restrict: 'A'
    link : (scope, element, attrs) ->
      element.on 'click', (e) ->
        e.preventDefault()
        offset = if element.hasClass('nav-link-page') then -50 else 0
        scrollPage = new SmoothScroll()
        scrollPage.animateScroll(document.querySelector($(this).attr('href')), 0, {updateURL: false, header: '.header-placeholder', offset: offset, speed: 200, speedAsDuration: true})
  )
  
  .directive('spw', ->
    restrict: 'A'
    link: (scope, element, attrs) ->

      # Why sentinel? Observing the sticky element directly doesn't work because
      # when stuck, it's still visible (intersecting). A sentinel before the element
      # lets us detect when scrolling reaches the stick point.
      sentinel = document.createElement('div')
      sentinel.style.height = '1px'
      sentinel.style.pointerEvents = 'none'
      sentinel.style.visibility = 'hidden'
      
      element[0].parentNode.insertBefore(sentinel, element[0])
      
      observer = new IntersectionObserver(
        (entries) ->
          isStuck = !entries[0].isIntersecting
          element[0].toggleAttribute('stuck', isStuck)
        ,
        {threshold: [0, 1]}
      )
      observer.observe(sentinel)
      
      scope.$on '$destroy', ->
        observer.disconnect()
        sentinel.parentNode?.removeChild(sentinel) if sentinel.parentNode

  )

  .directive('headroom', ->
    restrict: 'A'
    link: (scope, element, attrs) ->
      content = document.getElementById('page-content')
      headroom  = new Headroom(element[0],
        offset: content.offsetTop - 150
        classes: 
          notTop: "person--not-top"
      )
      headroom.init()      
  )
  
  .directive('tooltip', ['$translate', ($translate) ->
    restrict: 'A'
    link: (scope, element, attrs) ->
      $translate(attrs.tooltipTitle).then (trs) ->          
        bootstrap.Tooltip.getOrCreateInstance(element, {
          title: trs
          trigger: 'hover'
        })
  ])

  .directive('scrollbar', ->
    restrict: 'A'
    link : (scope, element, attrs) ->
      element.scrollbar()
  )

  .directive('focusMe', ->
    scope:
      trigger: '=focusMe'
    link: (scope, element) ->
      scope.$watch('trigger', (value) ->
        if (value == true)
          element[0].focus()
          #scope.trigger = false    
      )  
  )


  .directive('scrollspy', ->
    restrict: 'A'
    link: (scope, element, attrs) ->
      scrollSpy = new bootstrap.ScrollSpy(document.body, {
        target: '#page-nav'
        offset: 115
      })
  )

  .directive('countdown', ->
    restrict: 'A'
    scope:
      event_start: '=countdown'
    link: (scope, element, attrs) ->
      if moment().isAfter(moment(scope.event_start)) 
        document.getElementById('countdown-all').classList.add('d-none')
      else
        start = moment(scope.event_start).format('YYYY/MM/DD HH:mm:ss')      
        element.countdown start, (event) ->
          $('#countdown-d').html(event.strftime('%D'))
          $('#countdown-h').html(event.strftime('%H'))
          $('#countdown-m').html(event.strftime('%M'))
          $('#countdown-s').html(event.strftime('%S'))
  )


  .directive('favcount', ->
    restrict: 'A'
    scope:
      count: '=favcount'
    link: (scope, element, attrs) ->
      scope.$watch 'count', (newVal, oldVal) ->
        element[0].classList.add('animate')
      , true

      element[0].addEventListener('animationend', (event) ->
        event.stopPropagation()
        element[0].classList.remove('animate')
      )
  )
  
  .directive('modalClose', ->
    restrict: 'A'
    link : (scope, element, attrs) ->
      modalId = element.closest('.modal').attr('id')
      $modal = $("##{modalId}")

      element.on 'click', (e) ->
        e.preventDefault()
        $modalVideo = $modal.find(".modal-video-src")
        $modalVideo.attr("src", '')
        $modal.modal('hide')

        scope.$applyAsync()
  )

  .directive "compareTo", () ->
    require: "ngModel"
    scope:  
      confirmPassword: "=compareTo"
    link: (scope, element, attributes, modelVal) ->
      modelVal.$validators.compareTo = (val) ->
        return true unless val
        return val == scope.confirmPassword
      scope.$watch "confirmPassword", () ->
        modelVal.$validate()

  .directive('fileModel', ['$parse', ($parse) ->
    return
      restrict: 'A'
      link: (scope, element, attrs) ->
        model = $parse(attrs.fileModel)
        modelSetter = model.assign
        
        element.bind 'change', () ->
          scope.$apply () ->
            modelSetter(scope, element[0].files[0])

  ])
  

  .directive 'onErrorSrc', () ->
    return
      link: (scope, element, attrs) ->
        element.bind 'error', () ->
          if (attrs.src != attrs.onErrorSrc)
            attrs.$set('src', attrs.onErrorSrc)
        
  .directive('myEnter', () ->
    return (scope, element, attrs) ->
      element.bind("keydown keypress",  (event) ->
        if (event.which == 13)
          scope.$apply(() ->
            scope.$eval(attrs.myEnter)
          )
          event.preventDefault()        
      )
  )

  .directive('floatClose', ->
    restrict: 'A'
    link : (scope, element, attrs) ->
      fvID = element.closest('.fv').attr('id')
      $fv = $("##{fvID}")

      element.on 'click', (e) ->
        $floatVideo = $fv.find(".ritem")
        src = $floatVideo.attr("src")
        $floatVideo.attr("src", '')
        #$floatVideo.attr("src", src)
        scope.$applyAsync()
  )

  .directive "validEmail", () ->
    require: "ngModel"
    scope:  
      email: "=validEmail"
    link: (scope, element, attributes, modelVal) ->
      modelVal.$validators.validEmail = (val) ->
        return false unless val
        return scope.email

      scope.$watch "email", () ->
        modelVal.$validate()



  .directive('frvideo', ['$rootScope', (root) ->
    restrict: 'A'
    replace: true
    scope:
      frvideo: '=frvideo'
      frcid: '=frcid'
      freid: '=freid'
    link: (scope, element, attributes, modelVal) ->      
      scope.lang = root.lang

      autoplay = if attributes.autoplay then 'autoplay="1"' else ''
      scope.frcid = 1000 unless scope.frcid
      scope.freid = 2000 unless scope.freid
      element[0].innerHTML = "<b12-videoplayer ssp-device='VideoF_0' ssp-url='' uids='" + scope.frvideo + "' " + autoplay + " cid='" + scope.frcid + "' eid='" + scope.freid + "' elg='" + scope.lang + "'></b12-videoplayer>"

  ]) 

  .directive('paginationFor', ->
    restrict: 'A'
    template: '
      <nav ng-show="table.data.pages > 1">
        <ul class="pagination jc-c gap-12 fw-wrap">
          <li class="page-item" ng-class="{disabled: table.params.page == 1}"><a class="page-link" href rel="noffolow" ng-click="table.setPage(table.params.page - 1)"><svg class="fi fi-16 d-inline-block"><use xlink:href="assets/img/icons/feather-sprite.svg#chevron-left"/></svg></a></li>
          <li class="page-item" ng-repeat="page in table.pagination track by $index" ng-class="{active: table.params.page == page, disabled: !page}">
            <a href rel="noffolow" class="page-link" ng-click="table.setPage(page)" ng-show="page">{{ page }}</a>
            <a href rel="noffolow" class="page-link" ng-hide="page">&hellip;</a>
          </li>
          <li class="page-item" ng-class="{disabled: table.params.page == table.data.pages}"><a class="page-link" href rel="noffolow" ng-click="table.setPage(table.params.page + 1)"><svg class="fi fi-16 d-inline-block"><use xlink:href="assets/img/icons/feather-sprite.svg#chevron-right"/></svg></a></li>
        </ul>         
      </nav>'
    replace: true
    scope:
      table: '=paginationFor'
    controller: ['$scope', '$filter', (self, $filter) ->
      return
    ]
  ) 

  .directive('appointments', ['$window', '$rootScope', 'APITimes', '$location', ($window, root, APITimes, $location) ->
    restrict: 'A'
    template: '
      <div class="aus-footer" ng-show="isHasTimes()">
        <div class="aus-time" ng-class="{\'active\': booked}">
          <div ng-hide="booked">Make an appointment!</div>
          <div ng-show="booked">
            <div class="opacity-50">Your appointment:</div>
            {{ booked.display_3 }}
          </div>
          <span class="ic" ng-class="{\'ic-add ic-add-check active\': booked}"><svg class="fi"><use xlink:href="assets/img/icons/feather-sprite.svg#calendar"/></svg></span>
          <a href rel="noffolow" class="stretched-link" ng-click="openTimeModal()"></a>
        </div>
      </div>
    '
    replace: true
    scope:
      exhibitor: '=appointments'
      random: '='
    link : (self, element, attrs) ->      

      self.times = []
      getData = () ->
        #return unless root.user?.auth_ticket?
        ticket = root.user?.auth_ticket || 'tMzY1Ly8xNTMzOTcwLy8w'#'tMzAxLy8xNDY1MjcyLy8w' <--- fallback ticket for test
        times = APITimes.query {_entry: 'times', exhibitor_id: self.exhibitor, auth_ticket: ticket}, (data) ->
          self.times  = angular.copy(times)
          self.booked = false
          self.booked = self.times.filter((item) -> return item.booked)[0] || false
        return
      
      self.isHasTimes = () ->
        return root.user?.auth_ticket? && self.times.length > 0

      self.openTimeModal = () ->
        root.$broadcast('showTimeModal', self.times, 'updateListTime')
       
      self.$watch 'random', (oldObj, newObj) ->
        getData()
      , true 

      return 
  ])

  .directive('datepicker', ['$cookies', '$rootScope', ($cookies, root) ->
    restrict: 'A'
    require: 'ngModel'
    scope:
      theme: '='
      time: '='

    link: (self, element, attrs, ngModelCtrl) ->
      
      #timezone = root.setting('timezone') || 'Europe/Vienna'
      appTime  = $cookies.get("app_time") || moment().format()

      element.datetimepicker
        dayOfWeekStart: 1
        format: if !!self.time then 'H:i' else 'd/m/Y'
        lang: 'en'
        timepicker: !!self.time
        datepicker: !!!self.time
        closeOnDateSelect: true
        mask: if !!self.time then '99:99' else '39/19/9999'
        theme: self.theme
        onChangeDate: (dp, $input) ->
          self.$apply ->
            ngModelCtrl.$setViewValue(dp)

  ])


  .directive('datepickerr', ['$cookies', '$rootScope', ($cookies, root) ->
    restrict: 'A'
    scope:
      theme: '='
      time: '='

    link: (self, element, attrs) ->
      
      getTime = () ->
        return $cookies.get("app_time") || moment().format('DD/MM/YYYY kk:mm')


      element.datetimepicker
        dayOfWeekStart: 1
        format: 'd/m/Y H:i'
        formatTime: 'H:i'
        formatDate: 'd/m/Y'
        lang: 'en'
        timepicker: !!self.time
        datepicker: !!!self.time
        closeOnDateSelect: false
        theme: self.theme
        todayButton: true
        
        onChangeDateTime: (dp, $input) ->
          return unless dp
          self.$apply ->
            $cookies.put("app_time", moment(dp).format('DD/MM/YYYY kk:mm'))
            root.$broadcast 'fetchTime'

        onShow: (ct) ->        
          dt = getTime()
          this.setOptions({
            defaultDate: moment(dt, 'DD/MM/YYYY kk:mm').format('DD/MM/YYYY')
            defaultTime: moment(dt, 'DD/MM/YYYY kk:mm').format('kk:mm')
          })

  ])


  .directive('ytvideo', ['$rootScope', '$timeout', '$location', '$translate', (root, $timeout, $location, $translate) ->
    restrict: 'A'
    template: '
      <div id="ytPlayerWrap">
        <div class="ratio ratio-16x9 mh-100">
          <div class="video-next" ng-show="videoReady" ng-class="{\'video-next-full\': !video}">
            
            <div ng-if="state != \'state\'" class="d-flex fd-column gap-5">          
              <div ng-show="before == 2 || before == 3" class="fw-n fs-2 lh-sm">{{ \'pages.program.text.continue_2\' | translate }}</div>
              <div class="h1 mb-0">{{ \'pages.program.text.p\' + before | translate }}</div>          
              <div class="text-info fs-2 m-0">{{ state }}</div>          
            </div>

            <div ng-if="state == \'state\'">

              <div ng-if="!next && !video" class="d-flex fd-column gap-5">
                <div class="h1 mb-0">{{ \'pages.program.text.p1\' | translate }}</div>
                <div class="fw-n fs-2 lh-sm">{{ \'pages.program.text.continue_1\' | translate }}</div>
              </div>

              <div ng-if="next && (!video || videoEnded)" class="d-flex fd-column gap-5">
                <div class="fw-n fs-2 lh-sm">{{ \'pages.program.text.continue_2\' | translate }}</div>    
                <div class="h1 mb-0">{{ lang == \'en\' ? next.title_en : next.title_de }}</div>
                <div class="text-info fs-2 m-0">{{ nes }}</div>  
              </div>

              <div ng-if="!next && video && videoEnded" class="d-flex fd-column gap-5">
                <div class="fw-n fs-2 lh-sm">{{ \'pages.program.soon\' | translate }}</div>    
              </div>

            </div>
          </div>

          <div id="ytPlayer"></div>
          <div class="video-toggle-mute" ng-class="{\'video-toggle-off\': muted, \'video-toggle-on\': !muted, \'toggled\': toggled}" ng-click="toggleMute()"></div>
          <a href ng-click="toggleFull()" class="fullscreen" ng-show="video && !videoEnded">
            <svg class="fi" ng-hide="fulls"><use xlink:href="assets/img/icons/siemens-sprite.svg#full-screen"/></svg>
            <svg class="fi" ng-show="fulls"><use xlink:href="assets/img/icons/siemens-sprite.svg#full-screen-exit"/></svg>
          </a>
        </div>
      </div>
    '
    replace: true
    scope:
      video: '=ytvideo'
      next: '=ytnext'
    link: (self, element, attrs) ->      
      
      self.lang = root.lang

      self.initDone = false

      init = () ->
        if self.next?.id < 0
          self.next = null
          return 

        trs = if self.lang is 'en' then 'january' else 'janvier'

        if self.next?
          self.nes = moment("#{self.next.dd} #{self.next.start}", 'YYYY-MM-DD HH:mm:ss')
          self.nes = if self.nes.minutes() > 0 then self.nes.format("D [#{trs}] YYYY, H[h]mm[m]") else self.nes.format("D [#{trs}] YYYY, H[h]")

        self.videoReady = false
        self.videoEnded = false
        self.initDone   = true

        locParams = $location.search()

        mmDate = moment()
        mmDate = moment(locParams.time, "hh:mm") if locParams.time?
        mmDate = mmDate.date(parseInt(locParams.day) + 20) if locParams.day

        self.state = "state"
        self.before = 1

      
        if mmDate.isBefore('2025-01-21 09:00:00')
          console.debug "state 1"
          self.before = 1
          self.state = "21 #{trs} 2025, 9h"
        else if mmDate.isBetween('2025-01-21 09:00:00', '2025-01-22 09:00:00') && !self.next # show next day program unless next and until next day start
          console.debug "state 2"
          self.before = 2
          self.state = "22 #{trs} 2025, 9h"
        else if mmDate.isBetween('2025-01-22 09:00:00', '2025-01-23 10:00:00') && !self.next # show next day program unless next and until next day start
          console.debug "state 3"
          self.before = 3
          self.state = "23 #{trs} 2025, 10h"

        

        unless self.video?.slot_content.yt_id
          console.debug "ready 1"
          self.videoReady = true
          return self.player?.destroy()

        locParams = $location.search()
        if locParams.time?
          current = moment(locParams.time, 'HH:mm:ss')
        else
          current = moment(moment().format('HH:mm:ss'), 'HH:mm:ss')

        start = moment(self.video.start, 'hh:mm:ss')
        start = moment.duration(current.diff(start)).as('seconds') || 0

        console.debug "ins-", self.video.slot_content.yt_id

        playerVars =
          enablejsapi: 1
          showinfo: 0
          controls: 0
          autoplay: 1
          mute: 1
          modestbranding: 0
          disablekb: 1
          rel: 0
          playsinline: 1
          origin: 'https://www.youtube.com'

        
        playerVars.start = start if self.video?.slot_type != 'livestream'


        YT.ready () ->
          self.player = new YT.Player("ytPlayer", {
            videoId: self.video.slot_content.yt_id
            playerVars: playerVars
            events: 
              'onReady': (event) ->
                console.debug "...video ready"
                self.videoReady = false

              'onStateChange': (event) ->
                if event.data >= 0
                  self.videoReady = true
                  console.debug "ready 2"
                console.debug "Data", event.data
                if (event.data == YT.PlayerState.ENDED)
                  console.debug "---video ended", self.video, self.next
                  self.videoEnded = true
                  self.player?.destroy()
                  self.$applyAsync()
                else if (event.data == YT.PlayerState.PLAYING)
                  console.debug "+++video playing"
                else if (event.data == YT.PlayerState.PAUSED)
                  console.debug "===video paused"
                  
          })

      self.fulls = false
      self.toggleFull = () ->
        el = document.getElementById('ytPlayerWrap')
        if !document.fullscreenElement
          el.requestFullscreen()
          self.fulls = true
        else if document.exitFullscreen
          document.exitFullscreen()
          self.fulls = false

      self.muted = true
      self.toggleMute = () ->
        self.toggled = true
        return unless self.player?.g
        if self.player.isMuted()
          self.muted = false
          self.player.unMute()
        else
          self.muted = true
          self.player.mute()
       
      self.$watchGroup ['video.id', 'next.id'], (newObj, oldObj) ->
        self.player?.destroy()
        init()
      , true 

      return
  ])


  .directive('fytvideo', ['$rootScope', '$timeout', '$location', '$translate', (root, $timeout, $location, $translate) ->
    restrict: 'A'
    template: '
      <div class="fp">
        <div class="fp-controls">
          <a href ng-click="toPrograms()"><svg class="fi"><use xlink:href="assets/img/icons/siemens-sprite.svg#link-extern"/></svg></a>
          <a href ng-click="toggleMute()"><svg class="fi" ng-show="muted"><use xlink:href="assets/img/icons/siemens-sprite.svg#volume-mute"/></svg><svg class="fi" ng-hide="muted"><use xlink:href="assets/img/icons/siemens-sprite.svg#volume-loud"/></svg></a>
          <a href ng-click="closePlayer()"><svg class="fi"><use xlink:href="assets/img/icons/siemens-sprite.svg#close"/></svg></a>
        </div>
        <div class="ratio ratio-16x9 fp-ratio">
          <div id="ytFloatPlayer" class="fp-video"></div>
          <div class="fp-overlay text-white"></div>
        </div>
      </div>
    '
    replace: true
    scope:
      video: '=fytvideo'
    link: (self, element, attrs) ->      
      
      init = () ->

        self.videoReady = false

        unless self.video?.slot_content.yt_id
          self.videoReady = true
          element[0].classList.remove('fp-show')
          return self.player?.destroy()

        self.videoEnded = false

        current = moment(moment().format('HH:mm:ss'), 'HH:mm:ss')

        start = moment(self.video.start, 'hh:mm:ss')
        start = moment.duration(current.diff(start)).as('seconds') || 0
        start = 0 if start < 0

        playerVars =
          enablejsapi: 1
          showinfo: 0
          controls: 0
          autoplay: 1
          mute: 1
          modestbranding: 0
          disablekb: 1
          rel: 0
          playsinline: 1
          origin: 'https://www.youtube.com'

        
        playerVars.start = start if self.video?.slot_type != 'livestream'

        YT.ready () ->
          self.player = new YT.Player("ytFloatPlayer", {
            videoId: self.video.slot_content.yt_id
            playerVars: playerVars
            events: 
              'onReady': (event) ->
                self.videoReady = true
              'onStateChange': (event) ->
                if (event.data == YT.PlayerState.ENDED)
                  self.videoEnded = true
                  element[0].classList.remove('fp-show')
                  self.player?.destroy()
                else if event.data >= 0
                  element[0].classList.add('fp-show')
                self.$applyAsync()
          })

      self.toPrograms = () ->
        return $location.path("/program")

      self.closePlayer = () ->
        self.video = null

      self.muted = true
      self.toggleMute = () ->
        self.toggled = true
        return unless self.player?.g
        if self.player.isMuted()
          self.muted = false
          self.player.unMute()
        else
          self.muted = true
          self.player.mute()
       
      self.$watch 'video', (newObj, oldObj) ->
        init()
      , true 

      return
  ])
